import { Drawer } from 'vaul';

import { cn } from '@/utils/cn';
import { useMediaQuery } from '@/hooks/use-media-query';
import { Dialog, DialogContent } from '@/components/dialog';

interface ModalProps {
  children: React.ReactNode;
  className?: string;
  showModal: boolean;
  setShowModal: () => void;
  hideCloseButton?: boolean;
}

export function Modal({
  children,
  className,
  showModal,
  setShowModal,
  hideCloseButton,
  variant,
}: ModalProps & { variant?: 'default' | 'video' }) {
  const { isMobile } = useMediaQuery();

  if (isMobile) {
    return (
      <Drawer.Root open={showModal} onClose={setShowModal}>
        <Drawer.Overlay
          className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm"
          onClick={setShowModal}
        />
        <Drawer.Portal>
          <Drawer.Content
            className={cn(
              'fixed inset-x-0 bottom-0 z-50 mt-24 overflow-hidden rounded-t-2xl border border-white/10 bg-background',
              className
            )}
          >
            <div className="sticky top-0 z-20 flex w-full items-center justify-center bg-inherit">
              <div className="my-3 h-1.5 w-16 rounded-full bg-muted-foreground/20" />
            </div>
            {children}
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    );
  }
  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent
        className={cn(
          'overflow-hidden p-0 md:rounded-2xl border-white/10',
          variant === 'video' ? 'w-[95vw] max-w-[1200px]' : 'md:max-w-md',
          className
        )}
        hideCloseButton={variant === 'video' ? true : hideCloseButton}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
